












































import { ButtonType, MessageType } from '@getaccept/lib-ui';
import { HeaderHelper } from '@getaccept/lib-shared/src/helpers/header.helper';
import UploadFileButton from '@getaccept/lib-shared/src/components/UploadFileButton.vue';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { UploadAttachmentStatus } from '../types/enums/upload-attachment-status';
import { AttachmentService } from '../../../api/attachments/services/attachment.service';

export default defineComponent({
  components: {
    UploadFileButton,
  },
  props: {
    attachmentId: { type: String, default: '' },
    requestedFileName: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const file = ref<File>(null);
    const status = ref<UploadAttachmentStatus>(null);
    const failed = ref(false);

    const actionsPrevented = computed(() => !!status.value && !failed.value);

    const fileName = computed(() => file.value?.name || '');

    const handleSelectFile = (newFile: File) => {
      file.value = newFile;
    };

    const upload = async () => {
      if (!file.value) {
        return;
      }

      failed.value = false;
      status.value = UploadAttachmentStatus.GettingUploadLink;
      const fileExtension: string = file.value?.name.split('.').pop();

      try {
        const {
          url,
          headers,
        }: { url: string; headers: string } = await AttachmentService.getUploadLink(
          props.attachmentId,
          fileExtension
        );

        status.value = UploadAttachmentStatus.UploadingAttachment;
        const formattedHeaders: Record<string, string> = HeaderHelper.formatHeaders(
          headers,
          file.value.type
        );
        await AttachmentService.upload(file.value, url, formattedHeaders);

        status.value = UploadAttachmentStatus.Finalizing;
        await AttachmentService.uploadDone(props.attachmentId, file.value?.name);

        emit('uploaded');
      } catch (e) {
        failed.value = true;
      } finally {
        status.value = UploadAttachmentStatus.Completed;
      }
    };

    return {
      file,
      status,
      failed,
      actionsPrevented,
      fileName,
      handleSelectFile,
      upload,
      ButtonType,
      MessageType,
    };
  },
});
